import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import EventNoteRoundedIcon from "@mui/icons-material/EventNoteRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import LibraryBooksRoundedIcon from "@mui/icons-material/LibraryBooksRounded";
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../contexts/ConfigContext";
function HomePage() {
  const navigate = useNavigate();
  const config = useConfig();

  const handleClick = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // 月は0から始まるため1を加え、2桁にフォーマット
    navigate(`/todos/${year}/${month}`);
  };

  const handleTemplateCreate = () => {
    // 強制的にログインページにリダイレクトし、`relogin=true`をパラメータとして付加
    navigate("/login?redirect=/templates");
  };

  const handleTodoListCreate = () => {
    navigate("/templates/select-template");
  };

  const handleEditStaff = () => {
    navigate("/login?redirect=/edit-staff");
  };

  const handleCheckList = () => {
    navigate("/checklists");
  };

  const handleDashboard = () => {
    navigate("/dashboard");
  };

  // config から enableCheckList フラグを取得（デフォルトは true）
  const checkListEnabled = Boolean(config?.features?.enableCheckList);
  const assigneeSelectionEnabled = Boolean(
    config?.features?.enableAssigneeSelection
  );

  const quickActions = [
    ...(assigneeSelectionEnabled
      ? [
          {
            title: "クルー情報を編集する",
            icon: <GroupsRoundedIcon color="primary" />,
            onClick: handleEditStaff,
          },
        ]
      : []),
    {
      title: "テンプレートを作る",
      icon: <LibraryBooksRoundedIcon color="primary" />,
      onClick: handleTemplateCreate,
    },
    {
      title: checkListEnabled
        ? "ワースケ/チェックリストを作る"
        : "ワースケを作る",
      icon: <AssignmentTurnedInRoundedIcon color="primary" />,
      onClick: handleTodoListCreate,
    },
    {
      title: "ワースケを使う",
      icon: <EventNoteRoundedIcon color="primary" />,
      onClick: handleClick,
    },
    ...(checkListEnabled
      ? [
          {
            title: "チェックリストを使う",
            icon: <AssignmentTurnedInRoundedIcon color="primary" />,
            onClick: handleCheckList,
          },
        ]
      : []),
    {
      title: "ダッシュボード",
      icon: <DashboardRoundedIcon color="primary" />,
      onClick: handleDashboard,
    },
  ];

  return (
    <Stack spacing={3}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            xl: "repeat(3, minmax(0, 1fr))",
          },
          gap: 2.5,
        }}
      >
        {quickActions.map((action) => (
          <Box key={action.title}>
            <Card sx={{ height: "100%" }}>
              <CardActionArea sx={{ height: "100%" }} onClick={action.onClick}>
                <CardContent
                  sx={{
                    py: 2,
                    px: 2.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                  }}
                >
                  {action.icon}
                  <Typography variant="subtitle1">{action.title}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
        ))}
      </Box>
    </Stack>
  );
}

export default HomePage;
